import React from "react";
import useController from "./controller";
import Ellipses from "../../components/Ellipses";
import { useTranslation } from "react-i18next";
import WrapperPage from "../../components/WrapperPage";
import BaseInput from "../../components/BaseInput";
import "./style.scss";
import Butterflies from "../../components/Butterflies";

export default function LinkWasNotSentPage() {
  const { onLinkCopyHandle, link } = useController();
  const { t } = useTranslation();
  return (
    <div className="rules-page-wrapper centering-page">
      <Butterflies className="endgame-butterflies" countEllipses={2} />
      <Ellipses className="rules-page-wrapper-ellipses" countEllipses={2} />
      <WrapperPage backBtn burgerMenu>
        <div className="link-was-not-sent">
          <div className="link-was-not-sent__description">
            {t("linkWasNotSent.description")}
          </div>
          <BaseInput
            id={`input-clipboard-target-link-was-not-sent`}
            name="link-was-not-sent"
            className="link-was-not-sent__invite-link--input"
            value={link}
            type="copy"
            wrapperStyle="link-was-not-sent__invite-link"
            copyOnClick={() => onLinkCopyHandle()}
          />
        </div>
      </WrapperPage>
    </div>
  );
}
